<template>
  <div class="d-flex flex-column-reverse flex-lg-column">
    <div class="d-flex align-items-end flex-wrap flex-lg-nowrap gap-4 mb-3">
      <div class="form-field w-100">
        <span class="caption">Business name</span>
        <input
          v-model.trim="filters.businessName"
          type="text"
          placeholder="All"
          class="">
      </div>
      <div class="form-field w-100">
        <span class="caption">Address / Store code / PlaceID</span>
        <input
          v-model.trim="filters.businessDetails"
          type="text"
          placeholder="All">
      </div>
      <div class="form-field w-100">
        <span class="caption">Search term</span>
        <input
          v-model.trim="filters.searchTerm"
          type="text"
          placeholder="All">
      </div>
      <div v-if="!options.noTags" class="form-field w-100">
        <span class="caption">Tags</span>
        <multiselect
          :options="allTags"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :searchable="true"
          :show-labels="false"
          :max-height="540"
          v-model="filters.selectedTags"
          placeholder="All">
          <template slot="selection" slot-scope="{ values, isOpen }">
            <span class="multiselect__single" v-if="values.length && !isOpen">
              {{ values.length }} tag{{ values.length !== 1 ? 's' : '' }} selected
            </span>
          </template>
        </multiselect>
      </div>
      <div class="form-field w-100">
        <span class="caption">Grid size</span>
        <multiselect
          v-model="filters.gridSize"
          :options="gridSizeFilterOptions"
          :multiple="false"
          :show-labels="false"
          :searchable="false"
          :max-height="540"
          placeholder="All">
          <template slot="singleLabel" slot-scope="{ option }">
            {{ option ? `${option}x${option}` : "All" }}
          </template>
          <template slot="option" slot-scope="{ option }">
            {{ option ? `${option}x${option}` : "All" }}
          </template>
        </multiselect>
      </div>
      <div class="form-field w-auto">
        <span>&nbsp;</span>
        <button :class="['btn btn-link mb-3 gap-2', { 'text-muted': isFilterCleared }]"
          :disabled="isFilterCleared"
          @click.prevent.stop="clearFilters">
          <i class="fas fa-eraser" />
          Clear filters
        </button>
      </div>
    </div>
    <div v-if="!options.noShowDeleted || !options.noWithUpdates" class="d-flex align-items-end gap-4 mb-3 mb-lg-0">
      <div v-if="!options.noShowDeleted" class="form-field">
        <Checkbox v-model="filters.deleted">
          Only deleted
        </Checkbox>
      </div>
      <div v-if="!options.noWithUpdates" class="form-field">
        <Checkbox v-model="filters.withUpdates" :disabled="true" id="inactive">
          With updates
        </Checkbox>
        <b-popover
          placement="top"
          target="inactive"
          custom-class="geogrids-popover p-1"
          triggers="hover">
          Coming soon
        </b-popover>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Checkbox from '../../components/checkbox.vue'

const INITIAL_FILTERS = {
  businessName: '',
  businessDetails: '',
  searchTerm: '',
  selectedTags: null,
  gridSize: null,
  deleted: false,
  withUpdates: false
}

export default {
  components: { Multiselect, Checkbox },
  props: {
    allTags: { type: Array, default: () => ([]) },
    gridSizeFilterOptions: { type: Array, required: true },
    options: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      filters: { ...INITIAL_FILTERS }
    }
  },
  computed: {
    isFilterCleared() {
      return !Object.values(this.filters).find((val) => val)
    }
  },
  methods: {
    clearFilters() {
      this.filters = { ...INITIAL_FILTERS }
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        if (this.filterTimeout) clearTimeout(this.filterTimeout)

        this.filterTimeout = setTimeout(() => {
          this.$emit('filterChanged', this.filters)
        }, 500)
      }
    }
  }
}
</script>
